export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name': 'Pixartprinting S.p.A. a socio unico',
  'privacy-policy': 'Política de privacidade',
}
